export default __webpack_public_path__ + "static/media/music-lesson.a41de6a5.svg";